import React from "react";

interface AddIconProps {
  size?: number | string;
  color?: string;
  className?: string;
  onClick?: () => void;
}

const ContactIcon: React.FC<AddIconProps> = ({ size = 20, color = '#1E1E1E' }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.1001 10.6499C10.0418 10.6415 9.96675 10.6415 9.90009 10.6499C8.43342 10.5999 7.26675 9.39986 7.26675 7.92486C7.26675 6.41653 8.48342 5.19153 10.0001 5.19153C11.5084 5.19153 12.7334 6.41653 12.7334 7.92486C12.7251 9.39986 11.5668 10.5999 10.1001 10.6499Z" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M15.6172 16.1499C14.1339 17.5083 12.1672 18.3333 10.0005 18.3333C7.83388 18.3333 5.86721 17.5083 4.38388 16.1499C4.46721 15.3666 4.96721 14.5999 5.85888 13.9999C8.14221 12.4833 11.8755 12.4833 14.1422 13.9999C15.0339 14.5999 15.5339 15.3666 15.6172 16.1499Z" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M10.0001 18.3333C14.6025 18.3333 18.3334 14.6023 18.3334 9.99996C18.3334 5.39759 14.6025 1.66663 10.0001 1.66663C5.39771 1.66663 1.66675 5.39759 1.66675 9.99996C1.66675 14.6023 5.39771 18.3333 10.0001 18.3333Z" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>

);

export default ContactIcon;
